module.exports = __webpack_public_path__ + "static/chan3-1d3f1f0330679c00b449879fe0975515.webp";